import get from 'lodash.get';
import { licenseUsageTypes } from 'shared/constants';

export const getLicenseUsageTypeOptions = (licensesInfo = {}, user = {}) => {
  const licensesInfoTypes = get(licensesInfo, 'license_types');
  const legacyUserTypes = get(user, 'license_types');
  const userLicenseTypes = Array.isArray(licensesInfoTypes)
    ? licensesInfoTypes
    : Array.isArray(legacyUserTypes)
      ? legacyUserTypes
      : [];

  const licenseTypesOptions = userLicenseTypes
    .slice()
    .sort()
    .map((usageType) =>
      licenseUsageTypes.find((licenseType) => licenseType.value === usageType),
    )
    .filter(Boolean);

  licenseTypesOptions.unshift(licenseUsageTypes[0]);
  return licenseTypesOptions;
};
